import { render, staticRenderFns } from "./section-gallery-with-text.vue?vue&type=template&id=1f035530&scoped=true"
import script from "./section-gallery-with-text.vue?vue&type=script&lang=js"
export * from "./section-gallery-with-text.vue?vue&type=script&lang=js"
import style0 from "./section-gallery-with-text.vue?vue&type=style&index=0&id=1f035530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f035530",
  null
  
)

export default component.exports